import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import Heading from "../../components/Heading";
import Navbar from "../../components/NavbarServices";
import S7 from "../../sections/S7_Message";
import Footer from "../../sections/S8_Footer";

const Wrapped = styled.div`
  //   padding-top: 80px;
  padding-bottom: 80px;
`;
const Wrapper = styled.div`
  padding-top: 80px;
  padding-bottom: 80px;
`;
const Cell = styled.a`
  color: blue;
  text-decoration: underline;
  cursor: pointer;
`;
const Paragraph = styled.p`
  width: 90%;
`;
const index = (props) => {
  return (
    <div>
      <Navbar>Services</Navbar>
      <Wrapped>
        <Container>
          <Wrapper>
            <Cell href="/services"> Services</Cell> {props.title}
          </Wrapper>
          <Grid container Spacing={0}>
            <Grid item xs={12} md={6}>
              <Heading fs="50px">{props.heading}</Heading>
              <Paragraph>{props.text}</Paragraph>
            </Grid>
            <Grid item xs={12} md={6}>
              <img className="img-fluid" src={props.Image} />
            </Grid>
          </Grid>
        </Container>
      </Wrapped>
      <S7 />
      <Footer />
    </div>
  );
};

export default index;
